import { GRAPHQL_REQUEST_GET_LOGIN_RESOLVED, LoginActionTypes } from "./types";

export const graphqlRequestGetLoginResolved = (data: {
    data: any;
  }): LoginActionTypes => ({
    type: GRAPHQL_REQUEST_GET_LOGIN_RESOLVED,
    payload: data,
  });